import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-system/dept/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getLazyList = (parentId, params) => {
  return request({
    url: '/api/blade-system/dept/lazy-list',
    method: 'get',
    params: {
      ...params,
      parentId
    }
  })
}

export const getAllDeptLeavesList = () => {
  return request({
    url: '/api/blade-system/dept/allDeptLeaves',
    method: 'get'
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-system/dept/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-system/dept/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-system/dept/submit',
    method: 'post',
    data: row
  })
}

export const getDept = (id) => {
  return request({
    url: '/api/blade-system/dept/detail',
    method: 'get',
    params: {
      id,
    }
  })
}

export const getDeptTree = (tenantId) => {
  return request({
    url: '/api/blade-system/dept/tree',
    method: 'get',
    params: {
      tenantId,
    }
  })
}

export const getDeptLazyTree = (parentId) => {
  return request({
    url: '/api/blade-system/dept/lazy-tree',
    method: 'get',
    params: {
      parentId
    }
  })
}

//getDeptTreeDataScope
export const getDeptTreeDataScope = () => {
  return request({
    url: '/api/blade-system/dept/tree-data-scope',
    method: 'get',
  }).then(res=>{
    res.data.data = res.data.data.filter(v=>(v.id!=='0'))
    return res;
  })
}

//  部门
export const getPostSelect = () => {
  return request({
    url: '/api/blade-system/post/select',
    method: 'get',
  }).then(res=>{
    // res.data.data = res.data.data.filter(v=>(v.id!=='0'))
    return res;
  })
}


//  部门
export const getSignDeptName = () => {
  return request({
    url: '/api/businessnotice/signDeptName',
    method: 'get',
  }).then(res=>{
    // res.data.data = res.data.data.filter(v=>(v.id!=='0'))
    return res;
  })
}

//tree-data-scope-all
export const getDeptTreeDataScopeAll = () => {
  return request({
    url: '/api/blade-system/dept/tree-data-scope-all',
    method: 'get',
  })
}

export const uploadImagesWithOCR = (file, type) => {
  return request({
    url: "/api/blade-system/dept//upload-images-with-ocr",
    method: "post",
    data: (function (file, type) {
      var form = new FormData();
      form.append("file", file);
      form.append("type", type);
      return form;
    })(file, type),
  });
};

//modifyBusinessLicense
export const modifyBusinessLicense = (data) => {
  return request({
    url: "/api/blade-system/dept/modify-business-license",
    method: "post",
    data: data
  });
};

//modifyDeptFreeSign
export const modifyDeptFreeSign = (data) => {
  return request({
    url: "/api/blade-system/dept/modify-dept-free-sign",
    method: "post",
    data: data
  });
};


//
export const getDeptSelect = () => {
  return request({
    url: "/api/blade-system/dept/select",
    method: "get"
  });
};


//treeData
export const treeData = (tenantId) => {
  return request({
    url: "/api/blade-system/dept/tree-data",
    method: "get",
    params: {
      tenantId
    }
  });
};

export const loanDivisionist = (data) => {
  return request({
    url: "/api/blade-loanDivision/loanDivision/list",
    method: "post",
    data: data
  });
};


///tree-data-scope-all
export const treeDataScopeAll = () => {
  return request({
    url: "/api/blade-system/dept/tree-data-scope-all",
    method: "get"
  });
};

//  利率
export const productsAndRates = () => {
  return request({
    url: '/api/blade-loanProductManagement/loanProductManagement/productsAndRates',
    method: 'get',
  }).then(res=>{
    return res;
  })
}

//  平台
export const platfromNameList = () => {
  return request({
    url: '/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/platfromNameList',
    method: 'get',
  }).then(res=>{
    return res;
  })
}

//  签批类型
export const processDefinitionKey = () => {
  return request({
    url: '/api/blade-businessNormalFlowable/businessNormalFlowable/getProcessDefinitionKey',
    method: 'post',
  }).then(res=>{
    return res;
  })
}

// 获取 外文公告 公司
export const getListByBulletin = () => {
  return request({
    url: '/api/blade-system/dept/getListByBulletin',
    method: 'get'
  })
}

// 查看列表代理商页面
export const getDeptList = (data) => {
  return request({
    url: '/api/blade-system/agent/page',
    method: 'post',
    data
  })
}

// 新增代理商
export const saveDeptAgent = (data) => {
  return request({
    url: '/api/blade-system/agent/save',
    method: 'post',
    data
  })
}

// 新增代理商详情
export const DeptAgentDetail = (id) => {
  return request({
    url: '/api/blade-system/agent/detail',
    method: 'get',
    params: {
      id
    }
  })
}

// 代理商删除
export const DeptAgentDel = (id) => {
  return request({
    url: '/api/blade-system/agent/remove',
    method: 'get',
    params: {
      id
    }
  })
}

// 获取代理商加盟的产品类型
export const getDeptProductList = (deptId) => {
  return request({
    url: '/api/blade-system/agent/getAgentProduct',
    method: 'get',
    params: {
      deptId
    }
  })
}

// 获取代理商对应产品类型的加盟详情
export const getDeptProductDetail = (data) => {
  return request({
    url: '/api/blade-loanInvestmentInfo/loanInvestmentInfo/joinDetail',
    method: 'post',
    data: {
      ...data
    }
  })
}

// 获取代理商概况列表
export const getAgentOverview = (data) => {
  return request({
    url: '/api/blade-agent/agent/agentOverview',
    method: 'post',
    data: {
      ...data
    }
  })
}

export const getCarPositionList = () => {
  return request({
    url: '/api/blade-system/dept/listAll',
    method: 'get',
  })
}